import { useMutation, useQueryClient } from "@tanstack/react-query";

import { updateProduct } from "api/product.api";
import { invalidateProductSide } from "lib/cacheInvalidation";

export const useUpdateProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, body }) => updateProduct(id, body),
    onSuccess: () => {
      invalidateProductSide(queryClient);
    },
  });
};
